import { MOCK_DATA_GET_RAFFLE_STATUS } from "@/app/(custom-header)/botb-refer-a-friend/MOCK_DATA";
import {
  MOCK_DATA_PRE_SUBSCRIPTION_DEFAULT,
  MOCK_DATA_PRE_SUBSCRIPTION_NO_COUNTDOWN,
  MOCK_DATA_PRE_SUBSCRIPTION_NO_OFFER,
} from "@/app/(general-header)/upsell-subscription-modal/MOCK_DATA";

export const getRAFStatus = (useMockData = false, abortController?: AbortController) => {
  if (useMockData) {
    return Promise.resolve({
      json: () => Promise.resolve(MOCK_DATA_GET_RAFFLE_STATUS),
    });
  }
  return fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/00000001/app/rafUserDetails`, {
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    signal: abortController?.signal,
  });
};

export const getPreSubscriptionData = (useMockData = false, mockType?: "default" | "noOffer" | "noCountdown") => {
  if (useMockData) {
    switch (mockType) {
      case "default":
        return Promise.resolve({ json: () => Promise.resolve(MOCK_DATA_PRE_SUBSCRIPTION_DEFAULT) });
      case "noOffer": {
        return Promise.resolve({ json: () => Promise.resolve(MOCK_DATA_PRE_SUBSCRIPTION_NO_OFFER) });
      }
      case "noCountdown": {
        return Promise.resolve({ json: () => Promise.resolve(MOCK_DATA_PRE_SUBSCRIPTION_NO_COUNTDOWN) });
      }
    }
  }
  return fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/00000001/app/GetPreSubscriptionModal`, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const postRAFFtu = () => {
  return fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/00000001/app/rafUserDetails`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify({
      ftu: false,
    }),
  });
};
